import useForm from 'hooks/form/useForm';
import React, { useEffect } from 'react';
import { RESET_PII_PROFILE_PERSONAL_DETAILS } from '../const';
import usePIIStore from '../hooks/usePIIStore';

const initialFormField = RESET_PII_PROFILE_PERSONAL_DETAILS;

const withFormPIIProfilePersonalDetailsInitial = (Component) => {
  const FormPIIProfilePersonalDetailsInitialComponent = (props) => {
    const { personalDetails } = usePIIStore();

    const {
      information,
      setInformation,
      validation,
      setValidation,
      checkAllowSubmit,
    } = useForm(initialFormField);

    useEffect(() => {
      setInformation(personalDetails);
    }, []);

    const newProps = {
      ...props,
      information,
      setInformation,
      validation,
      setValidation,
      checkAllowSubmit,
    };
    return <Component {...newProps} />;
  };
  return FormPIIProfilePersonalDetailsInitialComponent;
};

export default withFormPIIProfilePersonalDetailsInitial;
